import React from 'react';
import { Badge } from 'reactstrap';
import { NavLink } from 'react-router-dom';

const SidebarLinkContent = ({ title, icon, newLink, disabled = false, key }) => (
  <li key={key} className={`sidebar__link ${disabled ? 'sidebar__link--disabled' : ''}`}>
    {icon && icon}
    <p className='sidebar__link-title'>
      {title}{' '}
      {newLink ? (
        <Badge color='danger' pill className='ml-2'>
          <span> NOUVEAU </span>
        </Badge>
      ) : (
        ''
      )}
    </p>
  </li>
);

const SidebarLink = props => (
  <>
    {props.disabled && <SidebarLinkContent {...props} />}
    {!props.disabled && (
      <NavLink
        to={props.route}
        onClick={() => props.onClick(props.route)}
        activeClassName={(window.location.pathname === '/' || (props.route !== '/' && props.activeLink === props.route)) ? 'sidebar__link-active' : ''}
      >
        <SidebarLinkContent {...props} />
      </NavLink>
    )}
  </>
);

export default SidebarLink;
